import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../context/app'
import { withTheme } from 'theming'
import { isEmpty } from 'lodash'
import CustomImage from '../../components/customImage/customImage'
import useTemplateHook from '../../components/template/templateHook'

const MyFollowing = ({ theme }) => {
  const { athletePartnerData, userFollowingList } = useContext(AppContext)
  const [contentPartnerList, setContentPartnerList] = useState([])
  const { customNavigate, getTemplateImage } = useTemplateHook()

  useEffect(() => {
    if (athletePartnerData && athletePartnerData.length > 0 && userFollowingList) {
      const contentPartnerIds = userFollowingList['CONTENT_PARTNER']

      let followList = athletePartnerData.filter((p) => contentPartnerIds.includes(p._id))

      setContentPartnerList(followList)
    }
  }, [athletePartnerData, userFollowingList])

  return (
    <div className="min-h-full pb-4">
      <div className="text-center xl:mx-20 xl:text-left">
        <p
          className="underline text-md lg:text-2xl mb-2 lg:mt-10 "
          style={{ textTransform: 'capitalize', color: theme.c3 }}
        >
          My Following
        </p>
      </div>
      <div className="py-5 px-10 md:px-16 lg:px-20 grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5">
        {!isEmpty(contentPartnerList) &&
          contentPartnerList.map((partner, index) => (
            <div
              key={index}
              className="relative overflow-hidden transform transition duration-500 ease z-0 cursor-pointer"
              onClick={() => customNavigate('DIRECT', `/athlete${partner.page_url}`)}
            >
              <div className="bg-black rounded-lg overflow-hidden flex justify-center relative">
                <div className="static-img-scale">
                  <CustomImage
                    imageUrl={getTemplateImage(partner?.thumbnail)}
                    imgClass="aspect-video object-center"
                    loaderClass={'h-20 md:h-32'}
                    imgAlt={partner.name}
                  />
                </div>
              </div>
              <div
                style={{ color: theme.c4 }}
                // style={{ color: '#fff' }}
                className="py-[0.5rem] px-1 shadow-2xl"
              >
                <div className="mb-[0.5rem] flex justify-between items-center ">
                  <p className={`text-xs md:text-base font-bold line-clamp-1 `}>{partner.name}</p>
                </div>
              </div>
            </div>
          ))}
      </div>
      {isEmpty(contentPartnerList) && (
        <div className="flex justify-center align-middle max-h-full">
          <p style={{ color: theme.c4 }} className="text-xl md:text-3xl">
            {'Following list is empty'}
          </p>
        </div>
      )}
    </div>
  )
}

export default withTheme(MyFollowing)
